export const ActionTypes = {
  WORKER_STATUS_POLL: 'WORKER_STATUS_POLL',
}

export const pollWorkerStatus = data => (dispatch, getState, { api }) => {
  dispatch({ type: ActionTypes.WORKER_STATUS_POLL })
  return api.pollWorkerStatus(data)
}
